import { createTheme } from '@material-ui/core/styles';

export default createTheme({
    overrides: {
        MuiFilledInput: {
            root: {
            backgroundColor: 'rgba(0,0,0,0.05)',
            },
        },
    },
    typography: {
        fontFamily: [
            'Margem',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
        ].join(','),
    },
    palette: {
        primary: {          
          main: '#0a775a',
        },
    },
    imagemFundo: {
        height: '100vh',    
        backgroundSize: 'cover',
        display: 'flex',
        alignItems: 'center'
    },
    cardLogin: {
        maxHeight: '800px'
    }
});